
import React from 'react';
import classNames from 'classnames';

import map from 'lodash/map';


import {
  getJobFeedFieldRenderForType,
  makeJobFeedItemFieldClassName,
  makeJobFeedItemClassNames
} from './renderers.jsx';

const renderTdBase = ({ fieldName, className, content, label, index })=> 
  <td key={index} className={classNames('job-feed-item-cell', makeJobFeedItemFieldClassName(className || label || fieldName))}>
    {content}
  </td>;


const JobFeedTable = ({ jobs, displayFields }) => (
  <table className="job-feed-table">
    <thead>
      <tr>
        {
          map(displayFields.fields, ({ label }, i)=>
            <th key={i}>{label}</th>
          )
        }
      </tr>
    </thead>
    <tbody>
      {
        map(jobs, (job, jindex)=>
          <tr key={jindex} className={classNames('job-feed-item', makeJobFeedItemClassNames(job, displayFields.itemCssClassFields))}>
            {
              map(displayFields.fields, ({ type, ...displayInfo }, index)=>
                getJobFeedFieldRenderForType(type)({
                  render: renderTdBase,
                  index: index,
                  datum: job,
                  ...displayInfo
                })
              )
            }
          </tr>
        )
      }
    </tbody>
      
  </table>
);

export default JobFeedTable;